import request from '@/config/axios'

// 招投标项目 VO
export interface BidProjectVO {
  id?: number // 编号
  no?: string // 单号（zb-yyyyMMdd + 4 位自增）
  customerId?: number // 甲方名称（客户编号）
  customerName?: string // 甲方名称
  projectName?: string // 项目名称
  productId?: number // 对应产品（产品编号）
  productName?: string // 对应产品名称
  devLanguage?: number // 开发语言（字典 crm_bid_dev_language）
  projectNo?: string // 项目编号
  winTime?: string // 获标时间
  winDeadline?: string // 获标截止时间
  bidDeadline?: string // 投标截止时间
  presentTime?: string // 述标时间
  reachRequirement?: string // 达标要求
  reachPlace?: string // 达标地点
  bookFee?: number // 标书费用
  projectBudget?: number // 项目预算
  projectCycle?: string // 项目周期
  deposit?: number // 保证金
  projectStatus?: string // 项目状态（自由文本）
  remark?: string // 备注
  creator?: string // 申请人（用户编号）
  creatorName?: string // 申请人名称
  createTime?: Date // 创建时间
}

// 招投标项目 API
export const BidProjectApi = {
  // 查询招投标项目分页
  // sceneType：1 我负责的 / 3 我下属负责的；不传 = 全部招标（不做负责人过滤）
  getBidProjectPage: async (params: any) => {
    return await request.get({ url: `/crm/bid-project/page`, params })
  },

  // 查询招投标项目详情
  getBidProject: async (id: number) => {
    return await request.get({ url: `/crm/bid-project/get?id=` + id })
  },

  // 新增招投标项目
  createBidProject: async (data: BidProjectVO) => {
    return await request.post({ url: `/crm/bid-project/create`, data })
  },

  // 修改招投标项目
  updateBidProject: async (data: BidProjectVO) => {
    return await request.put({ url: `/crm/bid-project/update`, data })
  },

  // 删除招投标项目
  deleteBidProject: async (id: number) => {
    return await request.delete({ url: `/crm/bid-project/delete?id=` + id })
  },

  // 导出招投标项目
  exportBidProject: async (params: any) => {
    return await request.download({ url: `/crm/bid-project/export`, params })
  }
}
